package com.iregained.site.pages

import androidx.compose.runtime.Composable
import com.iregained.site.components.cms.CmsSection
import com.iregained.site.components.cms.DynamicSectionRenderer
import com.iregained.site.components.layouts.PageLayout
import com.iregained.site.components.widgets.BackToTopButton
import com.varabyte.kobweb.compose.css.dvh
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page

@Page("/contact")
@Composable
fun ContactPage() {
    val pageSections: List<CmsSection> = listOf(
        CmsSection.ContactRoutingSection(),
        CmsSection.ContactB2bDemoSection(),
        CmsSection.ContactPatientFormSection(),
        CmsSection.ContactSupportSection(),
    )

    PageLayout {
        Column(
            modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // DYNAMIC RENDERER LOOP
            pageSections.forEach { section ->
                DynamicSectionRenderer(section)
            }
        }
        BackToTopButton()
    }
}